import { Component, Inject } from '@angular/core';
import { DigisubservicesService } from '../services/digisubservices.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import * as XLSX from 'xlsx';
import { formatDate } from '@angular/common';
@Component({
  selector: 'app-prantwisebusiness',
  templateUrl: './prantwisebusiness.component.html',
  styleUrls: ['./prantwisebusiness.component.scss']
})
export class PrantwisebusinessComponent {

   
  datewisedata;
  today = new Date();
  startdate = '';
  enddate = '';
  datewiselist = [];
  tempdata = [];
  district:any;
  
  isLoading: boolean = false;
  subTypesName = [
    { name: 'वार्षिक', isVisible: false },
    { name: 'त्रैवार्षिक', isVisible: false },
    { name: 'पंचवार्षिक', isVisible: false },
    // { name: 'मुदत ठेव (पंचवार्षिक वर्गणीदार)', isVisible: false },
    // { name: 'रामसेवक ग्रंथयात्री', isVisible: false },
    // { name: 'लोकनेता गंथयात्री वार्षिक', isVisible: false },
    // { name: 'लोकमान्य ग्रंथयात्री वार्षिक वर्गणी', isVisible: false },
    // { name: 'हिंदुत्व ग्रंथयात्री', isVisible: false },
    // { name: 'हिंदुत्व 1', isVisible: false },
    // { name: 'हिंदुत्व 2', isVisible: false },
    // { name: 'आजीव', isVisible: false },
    // { name: 'अनामत', isVisible: false },
  ];
  totalth = 0;
  finalData = [];
  state: any;
  country: any;
  prant:any
  appliedFilters: any = {}; 

  constructor(
    private dialogref: MatDialogRef<PrantwisebusinessComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  ngOnInit(): void {

    // this.isLoading = true;
    //  this.prant = this.data.prant
    // this.datewisedata = this.data['data'];
    // console.log( this.datewisedata , "first data");

    // this.datewisedata = this.datewisedata.filter((item:any) =>{
    //    return item.prant_name === this.prant
    //    })
    //    console.log(this.datewisedata, "prant_name" );

    // this.startdate = this.data['startDate'];
    // this.enddate = this.data['endDate'];

    this.isLoading = true;

    // this.prant = this.data['prant'] || '';
    this.startdate = this.data['startDate'] || '';
    this.enddate = this.data['endDate'] || '';

    this.datewisedata = this.data['data'] || [];
    console.log(this.datewisedata, "first data");

    this.appliedFilters = this.data['appliedFilters'] || {};

		console.log("Applied Filters:", this.appliedFilters);

    if (this.prant && this.prant.trim() !== '') {
      this.datewisedata = this.datewisedata.filter((item: any) =>
        item?.prant_name?.trim() === this.prant.trim()
      );
      console.log(this.datewisedata, "filtered by prant_name");
    }



    let data = this.uniqueData(this.datewisedata, (a) => a.subscription_type);

    for (let i = 0; i < Object.keys(data).length; i++) {
      let flag = false;
      for (let j = 0; j < Object.keys(this.subTypesName).length; j++) {
        if (data[i]['subscription_type'] === this.subTypesName[j]['name']) {
          this.subTypesName[j]['isVisible'] = true;
          flag = true;
          break;
        }
      }
      if (!flag) {
     
        this.subTypesName.push({
          name: data[i]['subscription_type'],
          isVisible: true,
        });
        // }
      }
    }

    // console.log(this.subTypesName);
    // this.totalth = this.subTypesName.length * 3 + 4;
    this.totalth = this.subTypesName.filter(b => b.isVisible).length * 4 + 4;
    // this.getDateORrepwiselist();

    this.setData();
  }

// OLD METHOD 
  // setData() {
  //   // console.log(this.rojmelData);
  //   debugger;
  //   let uniqueDateData = this.uniqueData(
  //     this.datewisedata,
  //     (a) => a.state
  //   );

   
  //   console.log(uniqueDateData
  //   );
  //   let finalTotal = {};
  //   this.subTypesName.map((b: any, i) => {
  //     if (b.isVisible) {
  //       let name = this.getKey(b.name);
  //       finalTotal[name + '_एकूण'] = 0;
  //       finalTotal[name + '_नवीन'] = 0;
  //       finalTotal[name + '_नूतनीकरण'] = 0;
  //       if (i == 0) {
  //         finalTotal['name'] = 'एकूण';
  //         finalTotal['एकूण'] = 0;
  //         finalTotal['नवीन'] = 0;
  //         finalTotal['नूतनीकरण'] = 0;
  //       }
  //     }
  //   });

  //   for (let i = 0; i < uniqueDateData.length; i++) {
  //     let datewiseData = this.datewisedata.filter((a) => {
  //       return a.state === uniqueDateData[i]['state'];
  //     });
  //     console.log(uniqueDateData[i]['prant_name'], datewiseData);
  //     // let datewiseData = this.uniqueData(
  //     //   districtwiseData,
  //     //   (a) => a.taluka
  //     // );
  //     // let datewiseData = this.datewisedata.filter((a) => {
  //     //   return a.entry_date === uniqueDateData[i]['entry_date'];
  //     // });
  //     // console.log(datewiseData);
  //     let totalData = {};
  //     this.subTypesName.map((b: any, i) => {
  //       if (b.isVisible) {
  //         let name = this.getKey(b.name);
  //         totalData[name + '_एकूण'] = 0;
  //         totalData[name + '_नवीन'] = 0;
  //         totalData[name + '_नूतनीकरण'] = 0;
  //         if (i == 0) {
  //           totalData['एकूण'] = 0;
  //           totalData['नवीन'] = 0;
  //           totalData['नूतनीकरण'] = 0;
  //         }
  //       }
  //     });
  //     datewiseData.map((a: any, i) => {
  //       // if (i == 0) totalData['entry_date'] = a.entry_date;
  //       let name = this.getKey(a.subscription_type);
  //       totalData['crdt_voucher_date']=a.crdt_voucher_date
  //       totalData[name + '_एकूण'] += parseInt(a.total_amt);
  //       finalTotal[name + '_एकूण'] += parseInt(a.total_amt);
  //       totalData[name + '_नवीन'] += a.rcpt_type == 'New' ? 1 : 0;
  //       finalTotal[name + '_नवीन'] += a.rcpt_type == 'New' ? 1 : 0;
  //       totalData[name + '_नूतनीकरण'] += a.rcpt_type == 'Renew' ? 1 : 0;
  //       finalTotal[name + '_नूतनीकरण'] += a.rcpt_type == 'Renew' ? 1 : 0;
  //       totalData['एकूण'] += parseInt(a.total_amt);
  //       finalTotal['एकूण'] += parseInt(a.total_amt);
  //       totalData['नवीन'] += a.rcpt_type == 'New' ? 1 : 0;
  //       finalTotal['नवीन'] += a.rcpt_type == 'New' ? 1 : 0;
  //       totalData['नूतनीकरण'] += a.rcpt_type == 'Renew' ? 1 : 0;
  //       finalTotal['नूतनीकरण'] += a.rcpt_type == 'Renew' ? 1 : 0;
  //       totalData['state'] = a.state 
  //       totalData['prant'] = a.prant_name 


  //     });
  //     // datewiseData.push(totalData);
  //     this.finalData.push(totalData);
  //   }
  //   this.finalData.push(finalTotal);
  //   console.log(this.finalData);
  //   this.isLoading = false;
  // }


  //Correct Code 
// setData() {
//   this.isLoading = true;
//   this.finalData = [];

//   // --- helpers ---
//   const makeZeroRow = (name?: string) => {
//     const o: any = {
//       ...(name ? { name } : {}),
//       'वर्गणीदार संख्या': 0,
//       'रक्कम': 0,
//       'नवीन': 0,
//       'नूतनीकरण': 0,
//       'नूतनी-बाकी': 0
//     };
//     (this.subTypesName || []).forEach((sub: any) => {
//       if (!sub?.isVisible) return;
//       const k = this.getKey(sub.name);
//       o[`${k}_नवीन`] = 0;
//       o[`${k}_नूतनीकरण`] = 0;
//       o[`${k}_एकूण`] = 0;
//       o[`${k}_रक्कम`] = 0;
//       o[`${k}_नूतनी-बाकी`] = 0;
//     });
//     return o;
//   };

//   const addToRow = (row: any, rec: any) => {
//     const amt = Number(rec?.total_amt) || 0;
//     const rcpt = String(rec?.rcpt_type || '').toLowerCase(); // 'new' | 'renew'
//     const typeKey = this.getKey(String(rec?.subscription_type || ''));

//     row['वर्गणीदार संख्या'] += 1;
//     row['रक्कम'] += amt;
//     if (rcpt === 'new') row['नवीन'] += 1;
//     if (rcpt === 'renew') row['नूतनीकरण'] += 1;

//     if (typeKey) {
//       row[`${typeKey}_एकूण`] += 1;
//       row[`${typeKey}_रक्कम`] += amt;
//       if (rcpt === 'new') row[`${typeKey}_नवीन`] += 1;
//       if (rcpt === 'renew') row[`${typeKey}_नूतनीकरण`] += 1;
//     }
//   };

//   // --- group by country -> state -> prant -> district ---
//   const groups = new Map<string, any[]>();
//   for (const rec of this.datewisedata || []) {
//     const country = rec?.country || '—';
//     const state = rec?.state || '—';
//     const prant = rec?.prant_name || '—';
//     const district_name = rec?.district_name || '—';
//     const key = `${country}||${state}||${prant}||${district_name}`;
//     if (!groups.has(key)) groups.set(key, []);
//     groups.get(key)!.push({ ...rec, country, state, prant_name: prant, district_name });
//   }

//   const grand = makeZeroRow('एकूण');

//   // nested totals
//   const nested = new Map<string, any[]>(); // for ordered push

//   for (const [key, rows] of groups) {
//     const [country, state, prant, district_name] = key.split('||');

//     // --- district total ---
//     const distTotal = makeZeroRow();
//     distTotal.country = country;
//     distTotal.state = state;
//     distTotal.prant_name = prant;
//     distTotal.district_name = district_name;
//     distTotal.isDistrictTotal = true;

//     for (const rec of rows) {
//       addToRow(distTotal, rec);
//       addToRow(grand, rec);
//     }

//     // pending for district
//     distTotal['नूतनी-बाकी'] =
//       distTotal['वर्गणीदार संख्या'] - distTotal['नूतनीकरण'];
//     (this.subTypesName || []).forEach((sub: any) => {
//       if (!sub?.isVisible) return;
//       const k = this.getKey(sub.name);
//       distTotal[`${k}_नूतनी-बाकी`] =
//         distTotal[`${k}_एकूण`] - distTotal[`${k}_नूतनीकरण`];
//     });

//     const prantKey = `${country}||${state}||${prant}`;
//     if (!nested.has(prantKey)) nested.set(prantKey, []);
//     nested.get(prantKey)!.push(distTotal);
//   }

//   // --- build finalData ---
//   for (const [prantKey, distTotals] of nested) {
//     const [country, state, prant] = prantKey.split('||');

//     // push all districts first
//     for (const d of distTotals) {
//       this.finalData.push(d);
//     }

//     // prant total
//     const prantTotal = makeZeroRow();
//     prantTotal.country = country;
//     prantTotal.state = state;
//     prantTotal.prant_name = prant;
//     prantTotal.isPrantTotal = true;

//     for (const d of distTotals) {
//       for (const k in d) {
//         if (typeof d[k] === 'number') {
//           prantTotal[k] = (prantTotal[k] || 0) + d[k];
//         }
//       }
//     }

//     this.finalData.push(prantTotal);
//   }

//   // finalize grand total
//   grand['नूतनी-बाकी'] = grand['वर्गणीदार संख्या'] - grand['नूतनीकरण'];
//   (this.subTypesName || []).forEach((sub: any) => {
//     if (!sub?.isVisible) return;
//     const k = this.getKey(sub.name);
//     grand[`${k}_नूतनी-बाकी`] =
//       grand[`${k}_एकूण`] - grand[`${k}_नूतनीकरण`];
//   });

//   this.finalData.push(grand);

//   this.isLoading = false;
// }


setData() {
  this.isLoading = true;
  this.finalData = [];

  // --- helpers ---
  const makeZeroRow = (name?: string) => {
    const o: any = {
      ...(name ? { name } : {}),
      'वर्गणीदार संख्या': 0,
      'रक्कम': 0,
      'नवीन': 0,
      'नूतनीकरण': 0,
      'नूतनी-बाकी': 0
    };
    (this.subTypesName || []).forEach((sub: any) => {
      if (!sub?.isVisible) return;
      const k = this.getKey(sub.name);
      o[`${k}_नवीन`] = 0;
      o[`${k}_नूतनीकरण`] = 0;
      o[`${k}_एकूण`] = 0;
      o[`${k}_रक्कम`] = 0;
      o[`${k}_नूतनी-बाकी`] = 0;
    });
    return o;
  };

  const addToRow = (row: any, rec: any) => {
    const amt = Number(rec?.total_amt) || 0;
    const rcpt = String(rec?.rcpt_type || '').toLowerCase(); // 'new' | 'renew'
    const typeKey = this.getKey(String(rec?.subscription_type || ''));

    row['वर्गणीदार संख्या'] += 1;
    row['रक्कम'] += amt;
    if (rcpt === 'new') row['नवीन'] += 1;
    if (rcpt === 'renew') row['नूतनीकरण'] += 1;

    if (typeKey) {
      row[`${typeKey}_एकूण`] += 1;
      row[`${typeKey}_रक्कम`] += amt;
      if (rcpt === 'new') row[`${typeKey}_नवीन`] += 1;
      if (rcpt === 'renew') row[`${typeKey}_नूतनीकरण`] += 1;
    }
  };

  // --- group by prant -> district ---
  const groups = new Map<string, any[]>();
  for (const rec of this.datewisedata || []) {
    // ✅ FIX: default unknown prant to "अन्य प्रांत"
    const prant = rec?.prant_name && rec.prant_name.trim() !== '' ? rec.prant_name : 'अन्य प्रांत';
    const district_name = rec?.district_name && rec.district_name.trim() !== '' ? rec.district_name : '—';

    const key = `${prant}||${district_name}`;
    if (!groups.has(key)) groups.set(key, []);
    groups.get(key)!.push({ ...rec, prant_name: prant, district_name });
  }

  const grand = makeZeroRow('एकूण');
  const nested = new Map<string, any[]>(); // prant -> districts

  for (const [key, rows] of groups) {
    const [prant, district_name] = key.split('||');

    // --- district total ---
    const distTotal = makeZeroRow();
    distTotal.prant_name = prant;
    distTotal.district_name = district_name;
    distTotal.isDistrictTotal = true;

    for (const rec of rows) {
      addToRow(distTotal, rec);
      addToRow(grand, rec);
    }

    // pending for district
    distTotal['नूतनी-बाकी'] =
      distTotal['वर्गणीदार संख्या'] - distTotal['नूतनीकरण'];
    (this.subTypesName || []).forEach((sub: any) => {
      if (!sub?.isVisible) return;
      const k = this.getKey(sub.name);
      distTotal[`${k}_नूतनी-बाकी`] =
        distTotal[`${k}_एकूण`] - distTotal[`${k}_नूतनीकरण`];
    });

    const prantKey = prant;
    if (!nested.has(prantKey)) nested.set(prantKey, []);
    nested.get(prantKey)!.push(distTotal);
  }

  // --- build finalData ---
  for (const [prant, distTotals] of nested) {
    if (!distTotals.length) continue; // skip empty prants

    // prant total
    const prantTotal = makeZeroRow();
    prantTotal.prant_name = prant;
    prantTotal.isPrantTotal = true;

    // push each district and accumulate for prant total
    for (const d of distTotals) {
      this.finalData.push(d); // district row

      for (const k in d) {
        if (typeof d[k] === 'number') {
          prantTotal[k] = (prantTotal[k] || 0) + d[k];
        }
      }
    }

    this.finalData.push(prantTotal); // prant total row (right after its districts)
  }

  // finalize grand total
  grand['नूतनी-बाकी'] = grand['वर्गणीदार संख्या'] - grand['नूतनीकरण'];
  (this.subTypesName || []).forEach((sub: any) => {
    if (!sub?.isVisible) return;
    const k = this.getKey(sub.name);
    grand[`${k}_नूतनी-बाकी`] =
      grand[`${k}_एकूण`] - grand[`${k}_नूतनीकरण`];
  });

  this.finalData.push(grand);

  this.isLoading = false;
}






  getKey(name) {
    return name.replaceAll(' ', '_');
  }

  uniqueData(data, key) {
    return [...new Map(data.map((a) => [key(a), a])).values()];
  }

  exportExcel(fileName) {
    /* table id is passed over here */
    let element = document.getElementById('print-section');
    const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);

    /* generate workbook and add the worksheet */
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

    /* save to file */
    XLSX.writeFile(wb, fileName + '.xlsx');
  }

  //Main Report Method Use in all Printing Page
  show = false
 
// printPage() {
//   this.show = true;
//   const printContent = document.getElementById('print-section')?.outerHTML;
//   if (!printContent) {
//     console.error("Print section not found!");
//     return;
//   }

//   const printWindow = window.open('', '', 'width=1400,height=1000,top=50,left=50,scrollbars=yes');

//   if (printWindow) {
//     printWindow.document.open();
//     printWindow.document.write(`
//       <html>
//         <head>
//           <title>Print Report</title>
//           <style>
//             @media print {
//               @page { 
//                 size: A3 landscape; 
//                 margin: 5mm; 
//               }
//               body { 
//                 font-family: Arial, sans-serif; 
//                 font-size: 14px; 
//                 margin: 0; 
//                 padding: 5mm; 
//                 line-height: 1.2; 
//                 -webkit-print-color-adjust: exact;
//                 print-color-adjust: exact;
//               }
//               table { 
//                 width: 100%; 
//                 max-width: 100%;
//                 border-collapse: collapse; 
//                 table-layout: auto; /* auto adjust columns */
//                 page-break-inside: avoid; 
//               }
//               th, td { 
//                 padding: 2px; 
//                 border: 1px solid black; 
//                 text-align: center; 
//                 font-size: 10px; 
//                 line-height: 1.2; 
//                 white-space: normal; 
//                 word-break: break-word; 
//                 overflow-wrap: anywhere;
//               }
//               #print-section {
//                 zoom: 0.9; /* shrink to fit */
//               }
//               .noPrint { 
//                 display: none !important; 
//               }
//             }
//           </style>
//         </head>
//         <body>
//           <div id="print-section">
//             ${printContent}
//           </div>
//           <script>
//             window.onload = function() { 
//               window.print(); 
//               setTimeout(() => { window.close(); }, 500);
//             };
//           </script>
//         </body>
//       </html>
//     `);
//     printWindow.document.close();
//   } else {
//     console.error("Failed to open print window.");
//   }
// }


//  printPage() {
//         this.show = true;
      
//         const printContent = document.getElementById('print-section')?.innerHTML;
//         if (!printContent) {
//           console.error("Print section not found!");
//           return;
//         }
      
//         const printWindow = window.open('', '', 'width=1400,height=1000,top=50,left=50,scrollbars=yes');
      
//         if (printWindow) {
//           printWindow.document.open();
//           printWindow.document.write(`
//             <html>
//               <head>
//                 <title>Print Report</title>
//                 <style>
//                   @media print {
//                     @page {
//                       size: A3 landscape;
//                       margin: 10mm;
//                     }
      
//                     body {
//                       font-family: Arial, sans-serif;
//                       font-size: 13px;
//                       margin: 0;
//                       padding: 0;
//                     }
      
//                     table {
//                       width: 100%;
//                       border-collapse: collapse;
//                       page-break-inside: avoid;
//                     }
      
//                     th, td {
//                       border: 1px solid black;
//                       padding: 3px 5px;
//                       font-size: 14px;
                      
//                     }
      
//                     tr {
//                       page-break-inside: avoid;
//                       page-break-after: auto;
//                     }
      
//                     .noPrint {
//                       display: none;
//                     }
//                   }
      
//                   body {
//                     font-family: Arial, sans-serif;
//                     font-size: 13px;
//                   }
      
//                   table {
//                     width: 100%;
//                     border-collapse: collapse;
//                   }
      
//                   th, td {
//                     border: 1px solid black;
//                     padding: 3px 5px;
//                     text-align: center;
//                   }
//                 </style>
//               </head>
//               <body>
//                 <div>
//                   ${printContent}
//                 </div>
//                 <script>
//                   window.onload = function() {
//                     window.print();
//                     setTimeout(() => { window.close(); }, 500);
//                   };
//                 </script>
//               </body>
//             </html>
//           `);
//           printWindow.document.close();
//         } else {
//           console.error("Failed to open print window.");
//         }
//       }
   
printPage() {
  this.show = true;
  const printContent = document.getElementById('print-section')?.outerHTML;
  if (!printContent) {
    console.error("Print section not found!");
    return;
  }

  const printWindow = window.open('', '', 'width=1400,height=1000,top=50,left=50,scrollbars=yes');

  if (printWindow) {
    printWindow.document.open();
    printWindow.document.write(`
      <html>
        <head>
          <title>Print Report</title>
          <style>
            @media print {
              @page { 
                size: A3 landscape;
                margin: 5mm;
              }
              body { 
                font-family: Arial, sans-serif;
                font-size: 15px;
                margin: 0;
                padding: 5mm;
                line-height: 1.2;
              }
              table { 
                width: 100%;
                border-collapse: collapse;
                page-break-inside: avoid;
              }
              th, td { 
                padding: 2px;
                border: 1px solid black;
                text-align: center;
                font-size: 12px;
                line-height: 1.2;
              }
              .noPrint { display: none; }

              /* ---------------------------------- */
              /* 🅰 OPTION A – Auto-scaling (uncomment to use) */
              /* body {
                transform: scale(0.9);      /* adjust 0.8–1.0 as needed */
                transform-origin: top left;
              } */
              
              /* ---------------------------------- */
              /* 🅱 OPTION B – Dynamic column shrink (default) */
              table { table-layout: auto; }
              th, td { 
                max-width: 120px;          /* adjust max column width */
                white-space: normal;       /* allow wrapping */
                word-wrap: break-word;
                overflow-wrap: break-word;
              }
            }
          </style>
        </head>
        <body>
          <div id="print-section">
            ${printContent}
          </div>
          <script>
            window.onload = function() { 
              window.print(); 
              setTimeout(() => { window.close(); }, 500);
            };
          </script>
        </body>
      </html>
    `);
    printWindow.document.close();
  } else {
    console.error("Failed to open print window.");
  }
}

}
